import styled from 'styled-components';

export const Li = styled('li')`
  cursor: ${props => props.cursor || 'pointer'};
  user-select: ${props => props.userSelect || 'none'};
  width: ${props => props.width};
`;